import { render, staticRenderFns } from "./globalPayments.vue?vue&type=template&id=98dfbb60&scoped=true"
import script from "./globalPayments.vue?vue&type=script&lang=ts"
export * from "./globalPayments.vue?vue&type=script&lang=ts"
import style0 from "./globalPayments.vue?vue&type=style&index=0&id=98dfbb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dfbb60",
  null
  
)

export default component.exports